// extracted by mini-css-extract-plugin
module.exports = {"card":"checkoutform-module--card--2UObk","shippingWarning":"checkoutform-module--shippingWarning--1tYZX"};